import { Phone } from "lucide-react";
import { Link } from "react-router-dom";
import BrandLogo from "@/components/landing/BrandLogo";

export default function Header({ settings }) {
  return (
    <header className="w-full px-4 py-4 md:py-5" data-testid="site-header">
      <div className="max-w-[640px] mx-auto flex items-center justify-between gap-4">
        <Link
          to="/"
          className="flex items-center gap-3 hover:opacity-90 transition-opacity"
          aria-label={`${settings.business_name} home`}
          data-testid="header-home-link"
        >
          <BrandLogo size={40} iconSize={18} />
          <div>
            <h1
              className="text-lg md:text-xl font-semibold leading-tight"
              style={{ color: "var(--pp-ink)" }}
              data-testid="business-name"
            >
              {settings.business_name}
            </h1>
            <p className="text-xs" style={{ color: "var(--pp-muted)" }} data-testid="business-tagline">
              Book your pet's appointment
            </p>
          </div>
        </Link>
        <a
          href={`tel:${settings.business_phone.replace(/[^0-9]/g, "")}`}
          className="hidden sm:inline-flex items-center gap-2 text-sm font-medium hover:underline"
          style={{ color: "var(--pp-indigo)" }}
          data-testid="header-phone-link"
        >
          <Phone className="w-4 h-4" />
          {settings.business_phone}
        </a>
      </div>
    </header>
  );
}
